<template>
   <v-container class="pa-0">
        <v-card
            class="ma-0"
            width="100%"
            flat
            height="85vh"
        >

            <v-container class="wrapper-department">
                <!--header-->
                <v-container class="header d-flex justify-space-between pa-0">
                    <div class="d-flex align-baseline gap-3">
                        <v-text-field
                            class="flex-fill"
                            :label="$t('search in departments')"
                            append-icon="mdi-magnify"
                            v-model="search"
                            clear-icon="mdi-close"
                            outlined
                            dense
                            clearable
                            @click:clear="fetchDataWithoutSearch"
                        />
                        <span class="text-body-2">{{ totalItems }} دپارتمان</span>
                    </div>
                    <div class="d-flex align-center gap-3">
                        <!--delete all-->
                        <v-btn
                            custom
                            outlined
                            @click="deleteAllItems()"
                        >
                            <span>{{ $t("delete all") }}</span>
                        </v-btn>
                        <!--filter-->
                        <v-btn
                            custom
                            outlined
                            @click="filterDrawerVisibility = !filterDrawerVisibility"
                        >
                            <span class="ml-2">{{ $t("filters") }}</span>
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.64282 7.8795C3.77757 6.4845 2.44707 4.95 1.72032 4.0875C1.49532 3.8205 1.42182 3.62475 1.37757 3.2805C1.22607 2.1015 1.15032 1.512 1.49607 1.131C1.84182 0.75 2.45307 0.75 3.67557 0.75H12.3246C13.5471 0.75 14.1583 0.75 14.5041 1.13025C14.8498 1.51125 14.7741 2.10075 14.6226 3.27975C14.5776 3.624 14.5041 3.81975 14.2798 4.08675C13.5523 4.95075 12.2196 6.48825 10.3498 7.8855C10.2634 7.95278 10.1919 8.03735 10.14 8.13382C10.0881 8.23029 10.0568 8.33653 10.0483 8.44575C9.86307 10.494 9.69207 11.616 9.58557 12.183C9.41382 13.0995 8.11557 13.6508 7.41957 14.142C7.00557 14.4345 6.50307 14.0865 6.44982 13.6335C6.25067 11.9074 6.08214 10.1779 5.94432 8.44575C5.93661 8.33549 5.90579 8.22809 5.85384 8.13053C5.80189 8.03297 5.73 7.94744 5.64282 7.8795Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </v-btn>
                        <!--divider-->
                        <v-divider
                            class="custom"
                            inset
                            vertical
                        >
                        </v-divider>
                        <!--new department-->
                        <v-btn
                            custom
                            depressed
                            color="primary"
                            @click="dialog = true"
                        >
                            <span class="ml-2">{{ $t("new departman") }}</span>
                            <v-icon class="white--text">mdi-plus</v-icon>
                        </v-btn>
                    </div>
                </v-container>
                <!--body-->
                <v-container class="body pa-0">
                    <!--data table-->
                    <v-data-table
                        class="mt-6"
                        :headers="headers"
                        :items="items"
                        v-model="selected"
                        :single-select="singleSelect"
                        item-key="id"
                        show-select
                        dense
                        hide-default-footer
                    >
                        <template v-slot:item.name="{ item }">
                            <v-card-text class="text-body-1 pa-0">
                                <span class="grey--text text--darken-1">#{{ item.id }}</span>
                                {{ item.name }}
                            </v-card-text>
                        </template>
                        <template v-slot:item.branch="{ item }">
                            <v-card-text class="text-body-1 pa-0">
                                {{ item.branch }}
                                <span class="grey--text text--darken-1">{{ $t('unit') }}</span>
                            </v-card-text>
                        </template>
                        <template v-slot:item.priority="{ item }">
                            <v-card-text class="text-body-1 pa-0 grey--text text--darken-1">
                            {{ item.priority ? item.priority : 'بدون الویت' }}
                            </v-card-text>
                        </template>
                        <template v-slot:item.operation="{ item }">
                            <v-container class="d-flex align-center justify-center pa-0 gap-1">
                                <div
                                    @click="deleteItem(item)"
                                    style="cursor: pointer;"
                                >
                                    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"/>
                                    </svg>
                                </div>
                                <div
                                    @click="editItem(item)"
                                    style="cursor: pointer;"
                                >
                                    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </v-container>
                        </template>
                        <template v-slot:footer>
                            <v-container class="d-flex justify-space-between align-center">
                                <v-card-text>
                                    <span class="text-heading-5 grey--text text--darken-1">نمایش</span>
                                    {{ `${itemCounter}` }}
                                    <span class="text-heading-5 grey--text text--darken-1">از</span>
                                    {{ totalItems }}
                                </v-card-text>

                                <VPagination
                                    size="30"
                                    v-model="options.page"
                                    total-visible="10"
                                    :length="Math.ceil(totalItems / options.itemsPerPage)"
                                />
                            </v-container>
                        </template>
                    </v-data-table>
                </v-container>
                <!--dialogs =>>>> -->
                <!--delete all dialog-->
                <v-dialog
                    v-if="deleteAllBtnVisibility"
                    v-model="deleteAllDialog"
                    max-width="500px"
                >
                    <v-card class="pa-7">
                        <v-card-text>
                            <v-container class="d-flex justify-space-between align-center pa-0 mb-9">
                                {{ $t("are you sure you want to delete all items?") }}
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-container class="pa-0 d-flex justify-center gap-2">
                                <v-btn
                                    custom
                                    outlined
                                    class="flex-fill"
                                    @click="closeDeleteAllItem()"
                                >
                                    <span>{{ $t('cancel') }}</span>
                                </v-btn>
                                <v-btn
                                    custom
                                    depressed
                                    color="error flex-fill"
                                    @click="deleteAllItemsConfirm()"
                                >
                                    <span>{{ $t('delete all') }}</span>
                                </v-btn>
                            </v-container>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--(dialog both (create) and (edit) department)-->
                <v-dialog
                    v-model="dialog"
                    max-width="500px"
                >
                    <v-card class="pa-7">
                        <v-card-text>
                            <v-container class="d-flex justify-space-between align-center pa-0 mb-9">
                                <v-card-text class="pa-0 text-heading-5">{{ formTitle }}</v-card-text>
                                <v-icon
                                    style="cursor: pointer;"
                                    @click="close"
                                >
                                mdi-close
                                </v-icon>
                            </v-container>
                            <v-container class="pa-0">
                                <v-text-field
                                class="w-100 mb-2"
                                :label="$t('departman subtitle')"
                                solo
                                v-model="editedItem.name"
                                >
                                </v-text-field>
                                <v-select
                                :items="items"
                                :label="$t('choose branch')"
                                append-icon="mdi-chevron-down"
                                solo
                                class="mb-2"
                                v-model="editedItem.branch"
                                ></v-select>
                                <v-text-field
                                class="w-100"
                                :label="$t('showing priority')"
                                solo
                                v-model="editedItem.priority"
                                >
                                </v-text-field>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-container class="pa-0 d-flex justify-center gap-2">
                                <v-btn
                                    custom
                                    outlined
                                    class="flex-fill"
                                    @click="close"
                                >
                                    <span>{{ $t('cancel') }}</span>
                                </v-btn>
                                <v-btn
                                    custom
                                    depressed
                                    color="primary flex-fill"
                                    @click="save"
                                >
                                    <span>{{ dialogSave }}</span>
                                </v-btn>
                            </v-container>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--dialog delete each item department-->
                <v-dialog
                    v-model="dialogDelete"
                    max-width="500px"
                >
                    <v-card class="pa-7">
                        <v-card-text>
                            <v-container class="d-flex justify-space-between align-center pa-0 mb-9">
                                <v-card-text class="pa-0 text-heading-5">{{ removeDepartman }}</v-card-text>
                                <v-icon
                                    style="cursor: pointer;"
                                    @click="closeDelete"
                                >
                                mdi-close
                                </v-icon>
                            </v-container>
                            <v-container class="pa-0">
                                <v-card-text class="pa-0 text-heading-5">{{ deletedItem.name }}</v-card-text>
                                <v-card-text class="pa-0 text-body-1 mt-5">{{ deletedItem.branch }}</v-card-text>
                                <v-card-text class="pa-0 text-body-1 mt-5">{{ $t("are you sure you want to delete this departman?") }}</v-card-text>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-container class="pa-0 d-flex justify-center gap-2">
                                <v-btn
                                custom
                                outlined
                                class="flex-fill"
                                @click="closeDelete"
                                >
                                    <span>{{ $t('cancel') }}</span>
                                </v-btn>
                                <v-btn
                                custom
                                depressed
                                color="error flex-fill"
                                @click="deleteItemConfirm"
                                >
                                    <span>{{ $t('delete departman') }}</span>
                                </v-btn>
                            </v-container>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-card>

        <!--<v-navigation-drawer
            v-model="filterDrawerVisibility"
            absolute
            temporary
            width="350"
            height="100vh"
            class="d-flex flex-column"
        >
            <v-container class="pa-0">
                <v-container class="d-flex justify-space-between pa-5">
                    <v-card-text>{{ $t("filter") }}</v-card-text>
                    <v-icon
                        style="cursor: pointer;"
                        @click="filterDrawerVisibility = !filterDrawerVisibility"
                    >
                    mdi-close
                    </v-icon>
                </v-container>
                <v-list-item class="mb-3">
                    <v-select
                    :items="items"
                    :label="$t('grouping')"
                    append-icon="mdi-chevron-down"
                    solo
                    ></v-select>
                </v-list-item>
                <v-list-item class="mb-3">
                    <v-select
                    :items="items"
                    :label="$t('category')"
                    append-icon="mdi-chevron-down"
                    solo
                    ></v-select>
                </v-list-item>
                <v-list-item class="mb-3">
                    <v-select
                    :items="items"
                    :label="$t('subcategory')"
                    append-icon="mdi-chevron-down"
                    solo
                    ></v-select>
                </v-list-item>
                <v-list-item class="mb-3">
                    <v-select
                    :items="items"
                    :label="$t('status')"
                    append-icon="mdi-chevron-down"
                    solo
                    ></v-select>
                </v-list-item>
            </v-container>
            <v-container class="d-flex justify-end align-end pa-5 mb-9 gap-1" style="flex-grow: 1;">
                <v-btn
                    custom
                    color='primary'
                    class="flex-fill"
                >
                    <span>{{ $t("apply filters") }}</span>
                </v-btn>
                <v-btn
                    custom
                    outlined
                    class="flex-fill"
                >
                    <span>{{ $t("delete filters") }}</span>
                </v-btn>
            </v-container>
        </v-navigation-drawer>-->
   </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [],
    items: [],
    options: {
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: []
    },
    totalItems: 0,
    search: null,
    searchTimeout: null,
    selected: [],
    singleSelect: false,
    dialog: false,
    dialogDelete: false,
    deleteAllDialog: false,
    editedIndex: -1,
    deletedIndex: -1,
    editedItem: {
      id: '',
      name: '',
      branch: '',
      priority: ''
    },
    deletedItem: {
      id: '',
      name: '',
      branch: '',
      priority: ''
    },
    defaultItem: {
      name: '',
      branch: '',
      priority: ''
    },
    filterDrawerVisibility: false,

    deleteAllBtnVisibility: false
  }),
  methods: {
    initializeHeadersTable () {
      this.headers = [
        {
          text: this.$t('department_name'),
          value: 'name',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('department_branch'),
          value: 'branch',
          sortable: false
        },
        {
          text: this.$t('display-priority'),
          value: 'priority',
          sortable: false
        },
        {
          text: this.$t('operations'),
          value: 'operation',
          sortable: false,
          align: 'center'
        }
      ]
    },
    fetchData () {
      var app = this
      app.$axios.get(this.$endpoint + 'departments', {
        params: {
          page: this.options.page,
          options: JSON.stringify({ page: this.options.page, itemsPerPage: this.options.itemsPerPage }),
          search: this.search ? this.search : null
        }
      })
        .then(r => {
          this.items = r.data.data
          this.totalItems = r.data.total
        })
        .catch(e => {
          console.error('Error:', e)
        })
    },
    fetchDataWithoutSearch () {
      this.search = null
      this.fetchData()
    },

    editItem (item) {
      this.dialog = true
      this.editedItem = Object.assign({}, item)
      this.editedIndex = this.items.indexOf(item)
    },
    deleteItem (item) {
      this.dialogDelete = true
      this.deletedItem = Object.assign({}, item)
      this.deletedIndex = this.items.indexOf(item)
    },
    deleteItemConfirm () {
      this.items.splice(this.deletedIndex, 1)
      this.closeDelete()
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.deletedItem = Object.assign({}, this.defaultItem)
        this.deletedIndex = -1
      })
    },
    save () {
      // if save is (edit)
      if (this.editedIndex > -1) {
        console.log(this.editedIndex.id)
        var app = this
        app.$axios.put(this.$endpoint + 'departments/' + this.editedItem.id, {
          name: this.editedItem.name,
          branch_id: this.editedItem.branch
        })
          .then(r => {
            this.items.push(r.data.data)
          })
          .catch(e => {
            console.error('Error:', e)
          })
        Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        // if save is (create)
        var app = this
        app.$axios.post(this.$endpoint + 'departments', {
          name: this.editedItem.name,
          priority: this.editedItem.priority,
          branch_id: this.editedItem.branch
        })
          .then(r => {
            this.items = r.data.data
          })
          .catch(e => {
            console.error('Error:', e)
          })
        this.items.push(this.editedItem)
      }
      this.close()
    },
    isDeleteAllBtnVisible () {
      if (this.itemsOnCurrentPage == this.selected.length) {
        /* console.log(this.selected) */
        this.deleteAllBtnVisibility = true
      }
    },
    deleteAllItems () {
      this.deleteAllDialog = true
    },
    closeDeleteAllItem () {
      this.deleteAllDialog = false
    },
    deleteAllItemsConfirm () {
      this.selected.forEach(i => {
        const index = this.items.findIndex(item => item.id === i.id)
        if (index !== -1) {
          this.items.splice(index, 1)
        }
      })
      this.deleteAllBtnVisibility = false
      this.selected = []
      this.deleteAllDialog = false
    }

  },
  computed: {
    itemCounter () {
      return ((this.options.page - 1) * this.options.itemsPerPage) + this.items.length
    },

    formTitle () {
      return this.editedIndex === -1 ? this.$t('create new departman') : `${this.$t('edit departman')} ${this.editedItem.id}`
    },
    dialogSave () {
      return this.editedIndex === -1 ? this.$t('confirm and create') : this.$t('edit confirm')
    },
    removeDepartman () {
      return `${this.$t('delete departman')} ${this.deletedItem.id}`
    },
    itemsOnCurrentPage () {
      const start = (this.options.page - 1) * this.options.itemsPerPage
      const end = start + this.options.itemsPerPage
      return this.items.slice(start, end).length
    }
  },

  watch: {
    'options.page': {
      immediate: true,
      handler (newPage) {
        this.fetchData()
      }
    },
    search (val) {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        if (val) {
          this.fetchData()
        }
      }, 1000)
    },

    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    itemsOnCurrentPage (val) {
      /* console.log(val) */
    },
    selected (val) {
      if (val.length > 0) {
        this.isDeleteAllBtnVisible()
      }
    }

  },

  created () {
    this.fetchData()
    this.initializeHeadersTable()
  }

}
</script>

<style>
.wrapper-department {
    padding: 16px !important;
}
.wrapper-department .header .v-divider.custom {
    min-height: unset !important;
    max-height: unset !important;
    margin-top: 0 !important;
    border-color: silver !important;
}

.wrapper-department .v-data-table {
    border: 1px solid #999999;
    border-radius: 6px !important;
    padding: 4px;
}
.wrapper-department .v-data-table__wrapper {
    margin-bottom: 5%;
}
.wrapper-department .v-data-table-header {
    background-color: #D9D9D9;
    padding: 12px;
    height: 55px;
}
.wrapper-department .v-data-table-header tr th:first-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.wrapper-department .v-data-table-header tr th:last-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.wrapper-department .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.wrapper-department .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.wrapper-department .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    font-size: 9.5pt !important;
}
.wrapper-department .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd),
.wrapper-department .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    background-color: transparent !important;
    height: 73px;
}
.wrapper-department .v-pagination  {
    gap: .5rem;
}
.wrapper-department .v-pagination .v-pagination__navigation,
.wrapper-department .v-pagination .v-pagination__item {
    box-shadow: none;
    padding: 12px;
    border-radius: 12px;
    width: 36px;
    height: 36px;
    border: 1px solid #999999;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
}
.theme--light.v-pagination .v-pagination__item--active {
    color: #0066ff;
    background-color: transparent !important;
}
</style>
